import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]

import UnsupportedPage from '@/components/unsupported-pages/UnsupportedPage.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'HardwareAccelerationRequired',
  setup(__props) {

const seratoLink = process.env.VUE_APP_CLIENT_URI_SERATO_COM

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UnsupportedPage, null, {
    title: _withCtx(() => [
      _createTextVNode(" Serato Visualizer requires hardware acceleration to be enabled. Please enable this and reload the Visualizer. ")
    ]),
    body: _withCtx(() => [
      _createElementVNode("a", { href: _unref(seratoLink) }, "Serato Home", 8, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})